import _ from "lodash";
import React from "react";
import { connect as reactReduxConnect } from "react-redux";
// @ts-expect-error
import VideoLayout from "../../../../../modules/UI/videolayout/VideoLayout";
import { getConferenceNameForTitle } from "../../../base/conference/functions";
import { hangup } from "../../../base/connection/actions.web";
import { isMobileBrowser } from "../../../base/environment/utils";
import { translate } from "../../../base/i18n/functions";
import { setColorAlpha } from "../../../base/util/helpers";
import Chat from "../../../chat/components/web/Chat";
import MainFilmstrip from "../../../filmstrip/components/web/MainFilmstrip";
import ScreenshareFilmstrip from "../../../filmstrip/components/web/ScreenshareFilmstrip";
import StageFilmstrip from "../../../filmstrip/components/web/StageFilmstrip";
import CalleeInfoContainer from "../../../invite/components/callee-info/CalleeInfoContainer";
import LargeVideo from "../../../large-video/components/LargeVideo.web";
import LobbyScreen from "../../../lobby/components/web/LobbyScreen";
import { getIsLobbyVisible } from "../../../lobby/functions";
import { getOverlayToRender } from "../../../overlay/functions.web";
import ParticipantsPane from "../../../participants-pane/components/web/ParticipantsPane";
import Prejoin from "../../../prejoin/components/web/Prejoin";
import { isPrejoinPageVisible } from "../../../prejoin/functions";
import { toggleToolboxVisible } from "../../../toolbox/actions.any";
import { fullScreenChanged, showToolbox } from "../../../toolbox/actions.web";
import JitsiPortal from "../../../toolbox/components/web/JitsiPortal";
import Toolbox from "../../../toolbox/components/web/Toolbox";
import { LAYOUT_CLASSNAMES } from "../../../video-layout/constants";
import { getCurrentLayout } from "../../../video-layout/functions.any";
import { init } from "../../actions.web";
import { maybeShowSuboptimalExperienceNotification } from "../../functions.web";
import axios from "axios";
import { getData } from "../../../api";
import { AbstractConference, abstractMapStateToProps, } from "../AbstractConference";
import { updateSettings } from "../../../base/settings/actions";
import ConferenceInfo from "./ConferenceInfo";
import { default as Notice } from "./Notice";
// import LeftMenuComponent from "./left-menu";
/**
 * DOM events for when full screen mode has changed. Different browsers need
 * different vendor prefixes.
 *
 * @private
 * @type {Array<string>}
 */
const FULL_SCREEN_EVENTS = [
    "webkitfullscreenchange",
    "mozfullscreenchange",
    "fullscreenchange",
];
let isModalOpen = false;
let modalPollData = [];
let ActivePollData = [];
let udata = [];
let mdata = [];
let userRole = [];
let showPollModal = false;
/**
 * The conference page of the Web application.
 */
class Conference extends AbstractConference {
    /**
     * Initializes a new Conference instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this.showDataModal = (data, userData, meetingData) => {
            modalPollData = data;
            isModalOpen = true;
            udata = userData;
            mdata = meetingData;
        };
        this.closeModal = () => {
            modalPollData = [];
            isModalOpen = false;
        };
        this.handleNewPoll = (pollData, userData, meetingData) => {
            // console.log("handleNewPoll:", pollData);
            // console.log("handleNewPoll:", userData);
            // console.log("handleNewPoll:", meetingData);
            this.showDataModal(pollData, userData, meetingData);
        };
        // handleActivePoll = () => {
        //     this.ActiveDataModal(meetingData)
        // }
        this.submitVote = (user_id, poll_id, pollAnswer) => {
            // const { selectedPollId } = this.state;
            // console.log("poll_id pollAnsweruser_id", poll_id, pollAnswer, user_id);
            if (poll_id !== null) {
                axios
                    .post("https://api.smartparley.de/pollresult", {
                    user_id: user_id,
                    poll_id: poll_id,
                    poll_answer: pollAnswer,
                })
                    .then((response) => {
                    const { luanchPollList } = this.state;
                    this.setState({
                        isSubmitVote: true,
                    });
                    const updatedList = luanchPollList.includes(poll_id)
                        ? luanchPollList.filter((item) => item !== poll_id)
                        : [...luanchPollList, poll_id];
                    this.setState({ luanchPollList: updatedList });
                    // console.log(
                    //     "Vote submitted successfully:",
                    //     this.state.isSubmitVote,
                    //     response.data
                    // );
                    // showPollModal = false;
                    // this.closeModal();
                })
                    .catch((error) => {
                    console.error("Error submitting vote:", error);
                    // showPollModal = false;
                });
            }
            else {
                console.error("No poll selected");
            }
            // showPollModal = false;
        };
        this.endMeeting = (meeting_id) => {
            if (meeting_id !== null) {
                axios
                    .post(`https://api.smartparley.de/meeting/${meeting_id}`)
                    .then((response) => {
                    if (response.status === 200) {
                        console.log("Test", response.data);
                        window.location.href =
                            "https://meet.smartparley.de/";
                    }
                    else {
                        console.error("Meeting not ended", response.status, response.data);
                    }
                });
            }
        };
        this.launchPoll = (meeting_id, poll_id) => {
            // const { selectedPollId } = this.state;
            // console.log("meeting_id and Poll_id", meeting_id, poll_id);
            if (poll_id !== null) {
                axios
                    .post(`https://api.smartparley.de/polls/meeting/${meeting_id}/${poll_id}`)
                    .then((response) => {
                    this.setState({ isTimerVisible: true });
                    // console.log(
                    //     "this.state.isTimerVisible",
                    //     this.state.isTimerVisible
                    // );
                    // this.setState({ timer: timerString });
                    this.updateTimer();
                    // console.log("Poll launched successfully:", response.data);
                    // alert(response.data.message);
                })
                    .catch((error) => {
                    console.error("Error lauching poll:", error);
                });
            }
            else {
                console.error("No poll selected");
            }
        };
        this.stopPoll = (meeting_id, poll_id) => {
            // const { selectedPollId } = this.state;
            // console.log("meeting_id and Poll_id", meeting_id, poll_id);
            if (poll_id !== null) {
                axios
                    .post(`https://api.smartparley.de/poll/meeting/${meeting_id}/${poll_id}`)
                    .then((response) => {
                    // console.log(
                    //     "this.state.isTimerVisible",
                    //     this.state.isTimerVisible
                    // );
                    // this.setState({ timer: timerString });
                    // this.updateTimer();
                    this.setState((prevState) => ({
                        errorMessage: {
                            ...prevState.errorMessage,
                            [poll_id]: "Poll is emergency stopped",
                        },
                    }));
                    // console.log("Poll stopped successfully:", response.data);
                    // alert(response.data.message);
                })
                    .catch((error) => {
                    console.error("Error lauching poll:", error);
                });
            }
            else {
                console.error("No poll selected");
            }
        };
        this.standardStopPoll = (meeting_id, poll_id) => {
            if (poll_id !== null) {
                axios
                    .post(`https://api.smartparley.de/poll/meeting/standard/${meeting_id}/${poll_id}`)
                    .then((response) => {
                    // Update the state to reflect the poll has been marked as standard
                    this.setState((prevState) => ({
                        standardPollStatus: {
                            ...prevState.standardPollStatus,
                            [poll_id]: true,
                        },
                    }));
                    // Optionally, you can log or alert the response message
                    // console.log("Poll marked as standard successfully:", response.data);
                    // alert(response.data.message);
                })
                    .catch((error) => {
                    console.error("Error marking poll as standard:", error);
                    // Optionally, handle error state updates
                    this.setState((prevState) => ({
                        errorMessage: {
                            ...prevState.errorMessage,
                            [poll_id]: "Error marking poll as standard",
                        },
                    }));
                });
            }
            else {
                console.error("No poll selected");
            }
        };
        this.updateTimer = () => {
            this.setState((prevState) => {
                // Specify the type of prevState explicitly
                const [hours, minutes, seconds] = prevState.timer
                    .split(":")
                    .map(Number);
                let totalSeconds = hours * 3600 + minutes * 60 + seconds;
                totalSeconds--;
                if (totalSeconds < 0) {
                    this.clearTimerInterval();
                    return { timer: "00:00:00", isTimerVisible: false };
                }
                const updatedHours = Math.floor(totalSeconds / 3600);
                const updatedMinutes = Math.floor((totalSeconds % 3600) / 60);
                const updatedSeconds = totalSeconds % 60;
                const updatedTimer = `${String(updatedHours).padStart(2, "0")}:${String(updatedMinutes).padStart(2, "0")}:${String(updatedSeconds).padStart(2, "0")}`;
                return { timer: updatedTimer };
            });
        };
        this.clearTimerInterval = () => {
            if (this.timerInterval) {
                clearInterval(this.timerInterval);
                this.timerInterval = null;
            }
        };
        this.fetchPoll = (meeting_id, poll_id, user_id) => {
            // console.log(
            //     "meeting_id and Poll_id and user_id",
            //     meeting_id,
            //     poll_id,
            //     user_id
            // );
            if (poll_id !== null) {
                axios
                    .post(`https://api.smartparley.de/polls/meeting/${meeting_id}/${poll_id}/${user_id}`)
                    .then((response) => {
                    // console.log("Poll fetched successfully:", response.data);
                    // alert(response.data.message);
                })
                    .catch((error) => {
                    console.error("Error fetching poll:", error);
                });
            }
            else {
                console.error("No poll fetched");
            }
        };
        this.activePoll = (meetingId, userId) => {
            // console.log("userId activePoll new---", userId);
            axios
                .get(`https://api.smartparley.de/polls/activepoll/${meetingId}/${userId}`, {
            // Any additional configurations for the GET request
            })
                .then((response) => {
                // console.log("Response from data successfully:", response);
                let pollData = response.data;
                // console.log(
                //     "pollData is (inside activePoll/setInterval )-------1111",
                //     pollData,
                //     Object.keys(pollData).length
                // );
                // console.log("ActivePollData:", response.data);
                // console.log(
                //     "Type of pollData:",
                //     Array.isArray(pollData),
                //     pollData
                // );
                // console.log("meeting_end", response.data.meeting_end);
                if (response.data.meeting_end) {
                    window.location.href = "https://meet.smartparley.de/";
                }
                // Assuming the response contains poll data
                if (Object.keys(pollData).length > 0) {
                    // console.log("Data is Coming..........");
                    ActivePollData = pollData;
                    // this.setState({
                    //     checkActivePollData: pollData,
                    // });
                    // console.log(
                    //     "Active poll Data is (if block)..8888888888888.........",
                    //     pollData
                    // );
                    // if (this.state.isTimeOut === false) {
                    // console.log(
                    //     "Inside timeout (if block)...99999999999999........"
                    // );
                    this.setState({
                        checkActivePollData: pollData,
                        isTimeOut: true,
                        isPollActive: true,
                    });
                    // }
                }
                else {
                    // console.log(
                    //     "Active poll Data (else block)...........",
                    //     pollData
                    // );
                    this.setState({
                        checkActivePollData: null,
                        isTimeOut: false,
                        isPollActive: false,
                    });
                }
            })
                .catch((error) => {
                console.error("Error while calling API:", error);
            });
        };
        this.fetchResolution = (meetingId) => {
            axios
                .get(`https://api.smartparley.de/polls/fetchres/${meetingId}`, {
            // Any additional configurations for the GET request
            })
                .then((response) => {
                // console.log("resolution", response.data);
                // let resolutionTexts = response.data.text.map((item: any) => item.resolution_text);
                // console.log("resolutionTexts ",resolutionTexts );
                this.setState({ resolutionText: response.data.text });
            })
                .catch((error) => {
                console.error("Error while calling API:", error);
            });
        };
        this.fetchStatus = (meetingId) => {
            axios
                .get(`https://api.smartparley.de/polls/fetchallpolls/${meetingId}`, {
            // Any additional configurations for the GET request
            })
                .then((response) => {
                // let resolutionTexts = response.data.text.map((item: any) => item.resolution_text);
                // console.log("data ", response.data);
                this.setState({ Status: response.data.status });
            })
                .catch((error) => {
                console.error("Error while calling API:", error);
            });
        };
        this.fetchAllVote = (meetingId) => {
            axios
                .get(`https://api.smartparley.de/polls/fetchallvotes/${meetingId}`, {
            // Any additional configurations for the GET request
            })
                .then((response) => {
                // let resolutionTexts = response.data.text.map((item: any) => item.resolution_text);
                // console.log("vote data ", response.data);
                const allVoted = response.data.data;
                // Check if all users have voted for any poll
                const allUsersVoted = allVoted.some((item) => item.all_users_voted);
                this.setState({
                    AllVoted: allVoted,
                    allUsersVoted: allUsersVoted,
                });
            })
                .catch((error) => {
                console.error("Error while calling API:", error);
            });
        };
        this.state = {
            isShowBtn: false,
            activePollIdCheck: null,
            meetingDataAll: {},
            checkActivePollData: null,
            isSubmitVote: false,
            isTimeOut: false,
            isPollActive: false,
            luanchPollList: [],
            isClosedBrowser: false,
            timer: "00:00:00",
            isTimerVisible: false,
            resolutionText: [],
            Status: [],
            AllVoted: [],
            allUsersVoted: false,
            errorMessage: "",
            // timerInterval: null,
        };
        // this.;
        this.timerInterval = null;
        const { _mouseMoveCallbackInterval } = props;
        // Throttle and bind this component's mousemove handler to prevent it
        // from firing too often.
        this._originalOnShowToolbar = this._onShowToolbar;
        this._originalOnMouseMove = this._onMouseMove;
        this._onShowToolbar = _.throttle(() => this._originalOnShowToolbar(), 100, {
            leading: true,
            trailing: false,
        });
        this._onMouseMove = _.throttle((event) => this._originalOnMouseMove(event), _mouseMoveCallbackInterval, {
            leading: true,
            trailing: false,
        });
        // Bind event handler so it is only bound once for every instance.
        this._onFullScreenChange = this._onFullScreenChange.bind(this);
        this._onVidespaceTouchStart = this._onVidespaceTouchStart.bind(this);
        this._setBackground = this._setBackground.bind(this);
    }
    /**
     * Start the connection and get the UI ready for the conference.
     *
     * @inheritdoc
     */
    componentDidMount() {
        document.title = "SmartParley Meet";
        const { _roomName } = this.props;
        const sanitizedMeetingId = _roomName.replace(/\s/g, "");
        let meetingId;
        let userId;
        // let timer: any;
        getData(`authorization/meeting/${sanitizedMeetingId}/attend`).then((response) => {
            if (response.status === 200) {
                this.setState({
                    meetingDataAll: response.data,
                });
                console.log("conference/ Meeting Data", response.data);
                meetingId = response.data.meeting.id;
                let authorizetovote = response.data.authorizedToVote;
                // console.log("Autho", authorizetovote);
                // timer = response.data.meeting.polls.timer;
                // this.updateTimer(timer);
                // console.log("pollsssssss", response.data.meeting.polls);
                let meetingdata = response.data.meeting.id;
                let pdata = response.data.meeting.polls;
                let userData = response.data.meeting.user;
                userId = response.data.meeting.user.id;
                // console.log("UserIDs", userId);
                // let userRole = localStorage.getItem("role");
                // console.log("UserRole is", userRole);
                // let merge_data = [...pdata, udata];
                // console.log("merge_data", merge_data);
                this.handleNewPoll(pdata, userData, meetingdata);
                // pdata.map((pollData: any) => {
                //     console.log("single pollData polls", pollData);
                //     this.handleNewPoll(pollData);
                // });
                localStorage.setItem("meetingdata", JSON.stringify(response.data.meeting.id));
                localStorage.setItem("pdata", JSON.stringify(response.data.meeting.polls));
                localStorage.setItem("userData", JSON.stringify(response.data.meeting.user));
                localStorage.setItem("role", JSON.stringify(response.data.meetingInvitation.type));
                localStorage.setItem("meeting_code", JSON.stringify(response.data.meeting.code));
                localStorage.setItem("meeting_title", JSON.stringify(response.data.meeting.title));
                localStorage.setItem("meeting_agenda", JSON.stringify(response.data.meeting.agenda));
                localStorage.setItem("authorizedToVote", JSON.stringify(response.data.authorizedToVote));
                APP.store.dispatch(updateSettings({
                    displayName: `${response.data.meetingInvitation.first_name} ${response.data.meetingInvitation.last_name}`,
                    avatarURL: response.data.meetingInvitation.profile_image,
                    email: response.data.meetingInvitation
                        .email_address,
                }));
                this._start();
            }
            else {
                window.location.href =
                    "https://app-test.smartparley.de/not-authorized";
            }
        });
        setInterval(() => {
            if (meetingId) {
                this.activePoll(meetingId, userId);
            }
        }, 1000);
        setInterval(() => {
            if (meetingId) {
                this.fetchStatus(meetingId);
            }
        }, 2000);
        setInterval(() => {
            if (meetingId) {
                this.fetchAllVote(meetingId);
            }
        }, 1000);
        setInterval(() => {
            this.fetchResolution(meetingId);
        }, 3000);
    }
    /**
     * Calls into legacy UI to update the application layout, if necessary.
     *
     * @inheritdoc
     * returns {void}
     */
    componentDidUpdate(prevProps) {
        if (this.props._shouldDisplayTileView ===
            prevProps._shouldDisplayTileView) {
            return;
        }
        // TODO: For now VideoLayout is being called as LargeVideo and Filmstrip
        // sizing logic is still handled outside of React. Once all components
        // are in react they should calculate size on their own as much as
        // possible and pass down sizings.
        VideoLayout.refreshLayout();
    }
    /**
     * Disconnect from the conference when component will be
     * unmounted.
     *
     * @inheritdoc
     */
    componentWillUnmount() {
        APP.UI.unbindEvents();
        FULL_SCREEN_EVENTS.forEach((name) => document.removeEventListener(name, this._onFullScreenChange));
        APP.conference.isJoined() && this.props.dispatch(hangup());
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { _isAnyOverlayVisible, _layoutClassName, _notificationsVisible, _overflowDrawer, _showLobby, _showPrejoin, t, } = this.props;
        return (React.createElement("div", { id: "layout_wrapper", onMouseEnter: this._onMouseEnter, onMouseLeave: this._onMouseLeave, onMouseMove: this._onMouseMove, ref: this._setBackground },
            React.createElement(Chat, null),
            React.createElement("div", { className: _layoutClassName, id: "videoconference_page", onMouseMove: isMobileBrowser() ? undefined : this._onShowToolbar },
                React.createElement(ConferenceInfo, null),
                React.createElement(Notice, null),
                React.createElement("div", { id: "videospace", onTouchStart: this._onVidespaceTouchStart },
                    React.createElement(LargeVideo, null),
                    _showPrejoin || _showLobby || (React.createElement(React.Fragment, null,
                        React.createElement(StageFilmstrip, null),
                        React.createElement(ScreenshareFilmstrip, null),
                        React.createElement(MainFilmstrip, null)))),
                _showPrejoin || _showLobby || (React.createElement(React.Fragment, null,
                    React.createElement("span", { "aria-level": 1, className: "sr-only", role: "heading" }, t("toolbar.accessibilityLabel.heading")),
                    React.createElement(Toolbox, null))),
                _notificationsVisible &&
                    !_isAnyOverlayVisible &&
                    (_overflowDrawer ? (React.createElement(JitsiPortal, { className: "notification-portal" }, this.renderNotificationsContainer({
                        portal: true,
                    }))) : (this.renderNotificationsContainer())),
                React.createElement(CalleeInfoContainer, null),
                _showPrejoin && React.createElement(Prejoin, null),
                _showLobby && React.createElement(LobbyScreen, null)),
            isModalOpen && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "modal", style: {
                        width: "320px",
                        overflowY: "auto",
                        overflowX: "hidden",
                        height: "95%",
                        backgroundColor: "#141414",
                    } },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("h2", { style: {
                                color: "#FFF",
                                marginTop: "20px",
                                marginBottom: "20px",
                                fontSize: "20px",
                                marginLeft: "20px",
                            } }, "offene Abstimmungens"),
                        React.createElement("hr", { style: {
                                color: "#246FE5",
                            } }),
                        modalPollData.map((rowData, index) => (React.createElement("div", { key: index, style: {
                                border: "1px solid #ccc",
                                borderRadius: "8px",
                                padding: "10px",
                                display: "flex",
                                flexDirection: "column",
                                width: "220px",
                                backgroundColor: "#292929",
                                margin: "auto",
                                marginTop: "15px",
                                marginBottom: "15px",
                            } },
                            this.state.meetingDataAll
                                .meetingInvitation.type ===
                                "Host" &&
                                this.state.Status.map((item) => {
                                    if (rowData.poll_id ===
                                        item.id &&
                                        item.status ===
                                            "active") {
                                        return (React.createElement("button", { style: {
                                                fontSize: "12px",
                                                padding: "1px",
                                                borderRadius: "10px",
                                                width: "100px",
                                                height: "32px",
                                                backgroundColor: "#EA4210",
                                                border: "none",
                                                alignSelf: "end",
                                            }, onClick: () => {
                                                this.stopPoll(mdata, item.id);
                                            } }, "Abstimmung abbrechen"));
                                    }
                                    return null; // Return null if the condition is not met, to avoid errors
                                }),
                            this.state.Status.map((item) => {
                                if (rowData.poll_id ===
                                    item.id &&
                                    item.status === "stop") {
                                    return (React.createElement("div", { key: item.id },
                                        React.createElement("p", { style: {
                                                color: "red",
                                                fontSize: "14px",
                                                marginTop: "14px",
                                                border: "1px solid #FFFFFF",
                                                textAlign: "center",
                                                borderRadius: "8px",
                                                backgroundColor: "#3F3F3F",
                                                padding: "5px",
                                            } }, "Die Abstimmung wurde abgebrochen.")));
                                }
                                else {
                                    // If the poll is not emergency stopped or doesn't match rowData.poll_id, return null
                                    return null;
                                }
                            }),
                            this.state.meetingDataAll
                                .meetingInvitation.type ===
                                "Host" &&
                                this.state.AllVoted &&
                                this.state.AllVoted.map((item) => {
                                    if (rowData.poll_id ===
                                        item.id &&
                                        item.all_users_voted) {
                                        return (React.createElement("div", { key: item.id },
                                            React.createElement("p", { style: {
                                                    color: "#28C765",
                                                    fontSize: "14px",
                                                    marginTop: "14px",
                                                    border: "1px solid #FFFFFF",
                                                    textAlign: "center",
                                                    borderRadius: "8px",
                                                    backgroundColor: "#3F3F3F",
                                                    padding: "5px",
                                                } }, "Alle Stimmen wurden abgegeben.")));
                                    }
                                    else if (rowData.poll_id ===
                                        item.id &&
                                        !item.all_users_voted) {
                                        // Display remaining user count if all users haven't voted
                                        return (React.createElement("div", { key: item.id },
                                            React.createElement("p", { style: {
                                                    color: "orange",
                                                    fontSize: "14px",
                                                    marginTop: "14px",
                                                    border: "1px solid #FFFFFF",
                                                    textAlign: "center",
                                                    borderRadius: "8px",
                                                    backgroundColor: "#3F3F3F",
                                                    padding: "5px",
                                                } },
                                                item.remainingUserCount,
                                                " ",
                                                "Anzahl offener Stimmen")));
                                    }
                                    else {
                                        // If the poll is not emergency stopped or doesn't match rowData.poll_id, return null
                                        return null;
                                    }
                                }),
                            this.state.AllVoted &&
                                this.state.AllVoted.map((item) => {
                                    if (rowData.poll_id ===
                                        item.id &&
                                        item.previous_launched) {
                                        // For the Host
                                        if (this.state
                                            .meetingDataAll
                                            .meetingInvitation
                                            .type ===
                                            "Host" &&
                                            !item.all_users_voted) {
                                            return (React.createElement("div", { key: item.id },
                                                React.createElement("p", { style: {
                                                        color: "#F03810",
                                                        fontSize: "14px",
                                                        marginTop: "14px",
                                                        border: "1px solid #FFFFFF",
                                                        textAlign: "center",
                                                        borderRadius: "8px",
                                                        backgroundColor: "#3F3F3F",
                                                        padding: "5px",
                                                    } }, "Die Zeit zur Abstimmung ist abgelaufen. Die Abstimmung kann erneut er\u00F6ffnet werden.")));
                                        }
                                        else if (this.state
                                            .meetingDataAll
                                            .meetingInvitation
                                            .type ===
                                            "Unit Owner") {
                                            // For the Unit Owner
                                            if (!this.state.luanchPollList.includes(rowData.poll_id)) {
                                                return (React.createElement("div", { key: item.id },
                                                    React.createElement("p", { style: {
                                                            color: "#F03810",
                                                            fontSize: "14px",
                                                            marginTop: "14px",
                                                            border: "1px solid #FFFFFF",
                                                            textAlign: "center",
                                                            borderRadius: "8px",
                                                            backgroundColor: "#3F3F3F",
                                                            padding: "5px",
                                                        } }, "Abstimmung wurde bereits gestartet.")));
                                            }
                                            else {
                                                return null; // Poll is not in the launch poll list, so don't display any message
                                            }
                                        }
                                    }
                                    return null;
                                }),
                            React.createElement("h3", { style: {
                                    color: "#FFF",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                } },
                                "Agenda : ",
                                rowData.agenda),
                            React.createElement("hr", { style: {
                                    color: "#246FE5",
                                    width: "100%",
                                } }),
                            React.createElement("h2", { style: {
                                    color: "#FFF",
                                    fontSize: "14px",
                                    marginTop: "10px",
                                    fontWeight: "600",
                                } }, "Abstimmungstext :"),
                            React.createElement("div", { style: {
                                    width: "100%",
                                    height: "110px",
                                    overflowX: "hidden",
                                    overflowY: "auto",
                                    textAlign: "justify",
                                } },
                                React.createElement("h2", { style: {
                                        fontSize: "12px",
                                        marginTop: "10px",
                                        fontWeight: "100",
                                        color: "#BCBCBC",
                                    } }, this.state.resolutionText.map((item) => {
                                    if (rowData.poll_id ===
                                        item.id) {
                                        return (React.createElement("p", { key: item.id }, item.resolution_text));
                                    }
                                }))),
                            this.state.meetingDataAll
                                .meetingInvitation.type !==
                                "Host" &&
                                this.state.luanchPollList.includes(rowData.poll_id) ? (
                            // Poll end msg
                            React.createElement("p", { style: {
                                    color: "#28C765",
                                    fontSize: "14px",
                                    marginTop: "14px",
                                    border: "1px solid #FFFFFF",
                                    textAlign: "center",
                                    borderRadius: "8px",
                                    backgroundColor: "#3F3F3F",
                                    padding: "5px",
                                } }, "Sie haben bereits abgestimmt")) : (React.createElement("div", null,
                                React.createElement("div", { style: {
                                        marginTop: "7px",
                                    } }, this.state
                                    .meetingDataAll
                                    .meetingInvitation
                                    .type ===
                                    "Host" && (React.createElement("div", null, this.state
                                    .activePollIdCheck ===
                                    rowData.poll_id &&
                                    this.state
                                        .isShowBtn &&
                                    !this.state
                                        .errorMessage[rowData
                                        .poll_id] &&
                                    this.state
                                        .isPollActive ? ( // Check if the poll is active
                                React.createElement("div", null, !this
                                    .state
                                    .errorMessage[rowData
                                    .poll_id] &&
                                    !this.state.AllVoted.some((item) => item.id ===
                                        rowData.poll_id &&
                                        item.all_users_voted) && (React.createElement("div", null, this.state.AllVoted.map((item) => {
                                    if (rowData.poll_id ===
                                        item.id) {
                                        if (item.all_users_voted) {
                                            // If all users have voted for this poll, hide the components
                                            return null;
                                        }
                                        else {
                                            // If voting is ongoing for this poll, display the "Voting Started" message and "Standard Stop" or "Relaunch" button
                                            return (React.createElement("div", { key: item.id, style: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between", // Added to move elements to opposite ends
                                                } },
                                                !this
                                                    .state
                                                    .errorMessage[item
                                                    .id] && (React.createElement("div", { style: {
                                                        display: "flex",
                                                    } },
                                                    React.createElement("p", { style: {
                                                            color: "rgb(56, 203, 122)",
                                                            fontSize: "12px",
                                                            marginRight: "10px",
                                                        } }, "Abstimmung hat begonnen"))),
                                                React.createElement("div", { style: {
                                                        display: "flex",
                                                    } },
                                                    React.createElement("button", { style: {
                                                            fontSize: "12px",
                                                            padding: "1px",
                                                            borderRadius: "10px",
                                                            width: "100px",
                                                            height: "32px",
                                                            backgroundColor: "#FA8406",
                                                            border: "none",
                                                            alignSelf: "end",
                                                        }, onClick: () => {
                                                            this.standardStopPoll(mdata, item.id);
                                                        } }, "Abstimmung beenden"))));
                                        }
                                    }
                                    else {
                                        // For polls where `all_users_voted` is not true, render null
                                        return null;
                                    }
                                }))))) : (!this.state
                                    .errorMessage[rowData
                                    .poll_id] &&
                                    !this.state.AllVoted.some((item) => item.id ===
                                        rowData.poll_id &&
                                        item.all_users_voted) && (React.createElement("button", { style: {
                                        fontSize: "12px",
                                        padding: "1px",
                                        borderRadius: "10px",
                                        width: "68px",
                                        height: "32px",
                                        backgroundColor: "#246FE5",
                                        border: "none",
                                    }, onClick: () => {
                                        const pollId = rowData.poll_id;
                                        this.setState({
                                            isShowBtn: true,
                                            activePollIdCheck: pollId,
                                        });
                                        this.launchPoll(mdata, pollId);
                                    } }, this.state.AllVoted.find((item) => item.id ===
                                    rowData.poll_id)
                                    ?.previous_launched
                                    ? "Neustart"
                                    : "Start")))))),
                                (this.state.meetingDataAll
                                    .authorizedToVote ||
                                    this.state
                                        ?.checkActivePollData
                                        ?.pollsData) &&
                                    this.state.isShowBtn &&
                                    this.state
                                        .activePollIdCheck ===
                                        rowData.poll_id &&
                                    !this.state.luanchPollList.includes(rowData.poll_id) && (React.createElement("div", { style: {
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        marginTop: "10px",
                                    } },
                                    React.createElement("button", { style: {
                                            marginBottom: "7px",
                                            fontSize: "15px",
                                            padding: "10px",
                                            borderRadius: "10px",
                                            width: "68px",
                                            height: "38px",
                                            backgroundColor: "#E0FCF8",
                                            color: "black",
                                            border: "1px solid #28C76F",
                                        }, onClick: () => this.submitVote(udata.id, ActivePollData.pollId, "yes") }, "Ja"),
                                    React.createElement("button", { style: {
                                            marginBottom: "7px",
                                            fontSize: "15px",
                                            padding: "10px",
                                            borderRadius: "10px",
                                            width: "68px",
                                            height: "38px",
                                            backgroundColor: "#FFF0EE",
                                            color: "black",
                                            border: " 1px solid #C73B28",
                                        }, onClick: () => this.submitVote(udata.id, ActivePollData.pollId, "no") }, "Nein"),
                                    React.createElement("button", { style: {
                                            marginBottom: "7px",
                                            fontSize: "15px",
                                            padding: "10px",
                                            borderRadius: "10px",
                                            width: "68px",
                                            height: "38px",
                                            backgroundColor: "#FFE0C3",
                                            color: "black",
                                            border: "1px solid #FF9F43",
                                            lineHeight: "1",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            textAlign: "center",
                                        }, onClick: () => this.submitVote(udata.id, ActivePollData.pollId, "neutral") },
                                        "Enthal-",
                                        React.createElement("br", null),
                                        "tung"))),
                                this.state.meetingDataAll
                                    .meetingInvitation
                                    .type ===
                                    "Unit Owner" && (React.createElement("span", null, this.state
                                    ?.checkActivePollData
                                    ?.pollId ===
                                    rowData.poll_id ? (React.createElement("div", { style: {
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                    } },
                                    React.createElement("button", { style: {
                                            marginBottom: "7px",
                                            fontSize: "15px",
                                            padding: "10px",
                                            borderRadius: "10px",
                                            width: "68px",
                                            height: "38px",
                                            backgroundColor: "#E0FCF8",
                                            color: "black",
                                            border: "1px solid #28C76F",
                                        }, onClick: () => this.submitVote(udata.id, ActivePollData.pollId, "yes") }, "Ja"),
                                    React.createElement("button", { style: {
                                            marginBottom: "7px",
                                            fontSize: "15px",
                                            padding: "10px",
                                            borderRadius: "10px",
                                            width: "68px",
                                            height: "38px",
                                            backgroundColor: "#FFF0EE",
                                            color: "black",
                                            border: " 1px solid #C73B28",
                                        }, onClick: () => this.submitVote(udata.id, ActivePollData.pollId, "no") }, "Nein"),
                                    React.createElement("button", { style: {
                                            marginBottom: "7px",
                                            fontSize: "15px",
                                            padding: "10px",
                                            borderRadius: "10px",
                                            width: "68px",
                                            height: "38px",
                                            backgroundColor: "#FFE0C3",
                                            color: "black",
                                            border: "1px solid #FF9F43",
                                            lineHeight: "1",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            textAlign: "center",
                                        }, onClick: () => this.submitVote(udata.id, ActivePollData.pollId, "neutral") },
                                        "Enthal-",
                                        React.createElement("br", null),
                                        "tung"))) : (React.createElement("div", null,
                                    React.createElement("div", null,
                                        React.createElement("h2", { style: {
                                                color: "#F66B6B",
                                                fontSize: "14px",
                                                marginTop: "14px",
                                                border: "1px solid #FFFFFF",
                                                textAlign: "center",
                                                borderRadius: "8px",
                                                backgroundColor: "#3F3F3F",
                                                padding: "5px",
                                            } }, "Es wurden noch keine Stimmen abgegeben.")))))))))))),
                    React.createElement("div", { "aria-label": "End meeting for all" }, this.state.meetingDataAll.meetingInvitation
                        .type === "Host" && (React.createElement("button", { style: {
                            fontSize: "14px",
                            // padding: "10px",
                            width: "274px",
                            backgroundColor: "#440007",
                            color: "#FFFFFF",
                            textAlign: "center",
                            fontWeight: "bold",
                            // position: "absolute",
                            bottom: "2px",
                            // left: "20px",
                            // zIndex: "999",
                            padding: "10px",
                            // width: "100%"
                        }, onClick: () => {
                            this.setState({
                                isClosedBrowser: true,
                            });
                            this.endMeeting(mdata);
                        } },
                        React.createElement("i", { className: "fa-solid fa-phone-hangup", style: { marginRight: "5px" } }),
                        " ",
                        "Parley wird f\u00FCr alle Teilnehmer beendet.")))))),
            React.createElement(ParticipantsPane, null)));
    }
    /**
     * Sets custom background opacity based on config. It also applies the
     * opacity on parent element, as the parent element is not accessible directly,
     * only though it's child.
     *
     * @param {Object} element - The DOM element for which to apply opacity.
     *
     * @private
     * @returns {void}
     */
    _setBackground(element) {
        if (!element) {
            return;
        }
        if (this.props._backgroundAlpha !== undefined) {
            const elemColor = element.style.background;
            const alphaElemColor = setColorAlpha(elemColor, this.props._backgroundAlpha);
            element.style.background = alphaElemColor;
            if (element.parentElement) {
                const parentColor = element.parentElement.style.background;
                const alphaParentColor = setColorAlpha(parentColor, this.props._backgroundAlpha);
                element.parentElement.style.background = alphaParentColor;
            }
        }
    }
    /**
     * Handler used for touch start on Video container.
     *
     * @private
     * @returns {void}
     */
    _onVidespaceTouchStart() {
        this.props.dispatch(toggleToolboxVisible());
    }
    /**
     * Updates the Redux state when full screen mode has been enabled or
     * disabled.
     *
     * @private
     * @returns {void}
     */
    _onFullScreenChange() {
        this.props.dispatch(fullScreenChanged(APP.UI.isFullScreen()));
    }
    /**
     * Triggers iframe API mouseEnter event.
     *
     * @param {MouseEvent} event - The mouse event.
     * @private
     * @returns {void}
     */
    _onMouseEnter(event) {
        APP.API.notifyMouseEnter(event);
    }
    /**
     * Triggers iframe API mouseLeave event.
     *
     * @param {MouseEvent} event - The mouse event.
     * @private
     * @returns {void}
     */
    _onMouseLeave(event) {
        APP.API.notifyMouseLeave(event);
    }
    /**
     * Triggers iframe API mouseMove event.
     *
     * @param {MouseEvent} event - The mouse event.
     * @private
     * @returns {void}
     */
    _onMouseMove(event) {
        APP.API.notifyMouseMove(event);
    }
    /**
     * Displays the toolbar.
     *
     * @private
     * @returns {void}
     */
    _onShowToolbar() {
        this.props.dispatch(showToolbox());
    }
    /**
     * Until we don't rewrite UI using react components
     * we use UI.start from old app. Also method translates
     * component right after it has been mounted.
     *
     * @inheritdoc
     */
    _start() {
        APP.UI.start();
        APP.UI.bindEvents();
        FULL_SCREEN_EVENTS.forEach((name) => document.addEventListener(name, this._onFullScreenChange));
        const { dispatch, t } = this.props;
        dispatch(init());
        maybeShowSuboptimalExperienceNotification(dispatch, t);
    }
}
/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code Conference} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state) {
    const { backgroundAlpha, mouseMoveCallbackInterval } = state["features/base/config"];
    const { overflowDrawer } = state["features/toolbox"];
    return {
        ...abstractMapStateToProps(state),
        _backgroundAlpha: backgroundAlpha,
        _isAnyOverlayVisible: Boolean(getOverlayToRender(state)),
        _layoutClassName: LAYOUT_CLASSNAMES[getCurrentLayout(state) ?? ""],
        _mouseMoveCallbackInterval: mouseMoveCallbackInterval,
        _overflowDrawer: overflowDrawer,
        _roomName: getConferenceNameForTitle(state),
        _showLobby: getIsLobbyVisible(state),
        _showPrejoin: isPrejoinPageVisible(state),
    };
}
export default reactReduxConnect(_mapStateToProps)(translate(Conference));
